import React from "react";
import { Modal, Button, Row, Col, Form as RBForm } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";

const ReAppointmentModal = ({
  show,
  onHide,
  selectedPatient,
  doctors = [],
  availableTimes = [],
  validationSchema,
  onSubmit,
  handleDoctorChange,
  handleDateChange,
  statusOverride,
}) => {
  const formatTime = (t) => {
    const [h, m] = t.split(":");
    const hour = parseInt(h, 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12}:${m} ${suffix}`;
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="custom-modal"
    >
      <Modal.Header
        closeButton
        className="border-0"
       
      >
        <Modal.Title
          className="form-heading primary-class"
          style={{
            color: "var(--primary-color)",
            fontWeight: "bold",
          }}
        >
          {selectedPatient
            ? `Re-Appointment : ${selectedPatient.patientName}`
            : "Re-Appointment"}
        </Modal.Title>
      </Modal.Header>

      {selectedPatient && (
        <Modal.Body className="p-4 bg-white rounded">
          <Formik
            initialValues={{
              doctorId: selectedPatient?.doctorId || "",
              appointmentDate: selectedPatient?.appointmentDate || "",
              appointmentTime: selectedPatient?.appointmentTime || "",
              reason: selectedPatient?.reason || "",
              additionalPhone: "",
              status: statusOverride || "Pending",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, helpers) =>
              onSubmit({ ...values, status: statusOverride || "Pending" }, helpers)
            }
          >
            {({ values, errors, touched, handleChange, setFieldValue }) => (
              <Form>
                {/* Patient Info */}
                <RBForm.Group className="mb-3">
                  <RBForm.Label className="fw-semibold primary-class small">
                    Patient Name
                  </RBForm.Label>
                  <RBForm.Control
                    type="text"
                    value={selectedPatient?.patientName || ""}
                    disabled
                    className="bg-light"
                  />
                </RBForm.Group>

                <RBForm.Group className="mb-3">
                  <RBForm.Label className="fw-semibold primary-class small">
                    Phone Number
                  </RBForm.Label>
                  <RBForm.Control
                    type="text"
                    value={selectedPatient?.patientPhone || ""}
                    disabled
                    className="bg-light"
                  />
                </RBForm.Group>

                {/* Doctor Selection */}
                <RBForm.Group as={Row} className="mb-3">
  <RBForm.Label
    column
    sm={12}
    md={3}
    className="fw-semibold primary-class small"
  >
    Doctor
  </RBForm.Label>

  <Col sm={12} md={9}>
    <Field
      as="select"
      name="doctorId"
      className={`form-select form-select-sm small ${
        errors.doctorId && touched.doctorId ? "is-invalid" : ""
      }`}
      onChange={(e) => handleDoctorChange(e.target.value, setFieldValue)}
    >
      <option value="" className="small">Select Doctor</option>
      {doctors.map((doc) => (
        <option key={doc.id} value={doc.id} className="small">
          {doc.name} {doc.specialties ? `- ${doc.specialties}` : ""}
        </option>
      ))}
    </Field>

    {errors.doctorId && touched.doctorId && (
      <div className="invalid-feedback d-block">{errors.doctorId}</div>
    )}
  </Col>
</RBForm.Group>


                {/* Additional Phone */}
                <RBForm.Group className="mb-3">
                  <RBForm.Label className="fw-semibold primary-class small">
                    Additional Phone Number (Optional)
                  </RBForm.Label>
                  <Field
                    type="text"
                    name="additionalPhone"
                    placeholder="Enter additional phone number"
                    className={`form-control ${
                      errors.additionalPhone && touched.additionalPhone
                        ? "is-invalid"
                        : ""
                    }`}
                  />
                  <ErrorMessage
                    name="additionalPhone"
                    component="div"
                    className="text-danger mt-1"
                  />
                </RBForm.Group>

                {/* Appointment Date & Time */}
                <Row>
                  <Col md={6}>
                    <RBForm.Group className="mb-3">
                      <RBForm.Label className="fw-semibold primary-class small">
                        Appointment Date
                      </RBForm.Label>
                      <Field
                        type="date"
                        name="appointmentDate"
                        className={`form-control ${
                          errors.appointmentDate && touched.appointmentDate
                            ? "is-invalid"
                            : ""
                        }`}
                        disabled={!values.doctorId}
                        onChange={(e) =>
                          handleDateChange(
                            e.target.value,
                            values.doctorId,
                            setFieldValue
                          )
                        }
                      />
                      <ErrorMessage
                        name="appointmentDate"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </RBForm.Group>
                  </Col>

                  <Col md={6}>
                    <RBForm.Group className="mb-3">
                      <RBForm.Label className="fw-semibold primary-class small">
                        Appointment Time
                      </RBForm.Label>
                      <Field
                        as="select"
                        name="appointmentTime"
                        className={`form-select ${
                          errors.appointmentTime && touched.appointmentTime
                            ? "is-invalid"
                            : ""
                        }`}
                        disabled={!values.appointmentDate}
                      >
                        <option value="">Select Time</option>
                        {availableTimes.map((time) => {
                          const [start, end] = time.split(" -");
                          return (
                            <option key={time} value={time}>
                              {`${formatTime(start)} - ${formatTime(end)}`}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="appointmentTime"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </RBForm.Group>
                  </Col>
                </Row>

                {/* Reason */}
                <RBForm.Group className="mb-3">
                  <RBForm.Label className="fw-semibold primary-class small">
                    Reason
                  </RBForm.Label>
                  <Field
                    as="textarea"
                    name="reason"
                    rows="3"
                    className={`form-control ${
                      errors.reason && touched.reason ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="reason"
                    component="div"
                    className="text-danger mt-1"
                  />
                </RBForm.Group>

                {/* Submit */}
                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 fw-bold global-btn"
                  
                >
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      )}
    </Modal>
  );
};

export default ReAppointmentModal;
